import { render, staticRenderFns } from "./police.vue?vue&type=template&id=c16fd3d0&scoped=true"
import script from "./police.vue?vue&type=script&lang=js"
export * from "./police.vue?vue&type=script&lang=js"
import style0 from "./police.vue?vue&type=style&index=0&id=c16fd3d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16fd3d0",
  null
  
)

export default component.exports